import { FC, Fragment, PropsWithChildren, ReactElement, useEffect, useState } from 'react';
import '../register-web-components';
import { getCurrentLoB } from '../lib/utils/utils';
import Health100Footer from './health100-footer/health100-footer';

interface Props {
  pageName?: string;
}

const Footer: FC<PropsWithChildren<Props>> = ({
  pageName = 'App Store Feedback',
  children
}): ReactElement => {
  const [lob, setLob] = useState<string | null>(null);

  useEffect(() => {
    setLob(getCurrentLoB());
  }, []);

  if (lob === 'health100') {
    return (
      <Fragment>
        <Health100Footer />
        {children}
      </Fragment>
    );
  }

  if (lob === 'cvs') {
    return (
      <>
        <cvs-footer-component />
        {children}
      </>
    );
  }

  return <>{children}</>;
};

export default Footer;
